import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/destinations`;

/**
 * Get all destinations with optional filters
 * @param {Object} filters - Optional filters
 * @param {string} filters.search - Search term
 * @param {Array<string>} filters.tags - Tags to filter by
 * @param {boolean} filters.featured - Filter by featured status
 * @returns {Promise<Array>} Array of destinations
 */
export const getDestinations = async (filters = {}) => {
  const { search: searchTerm, tags: tagsFilter, featured: featuredFilter } = filters;
  
  // Build query parameters
  const params = new URLSearchParams();
  if (searchTerm) params.append('search', searchTerm);
  if (tagsFilter && tagsFilter.length > 0) {
    if (Array.isArray(tagsFilter)) {
      params.append('tags', tagsFilter.join(','));
    } else {
      params.append('tags', tagsFilter);
    }
  }
  if (featuredFilter !== undefined) params.append('featured', featuredFilter);
  
  const response = await axios.get(API_URL, { params });
  return response.data.data;
};

/**
 * Get featured destinations
 * @param {number} limit - Maximum number of destinations to return
 * @returns {Promise<Array>} Array of featured destinations
 */
export const getFeaturedDestinations = async (limit = 3) => {
  const params = new URLSearchParams();
  if (limit) params.append('limit', limit);
  
  const response = await axios.get(`${API_URL}/featured`, { params });
  return response.data.data;
};

/**
 * Get a destination by ID
 * @param {string} id - Destination ID
 * @returns {Promise<Object>} Destination object
 */
export const getDestinationById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data.data;
};

/**
 * Get a destination by name
 * @param {string} name - Destination name
 * @returns {Promise<Object>} Destination object
 */
export const getDestinationByName = async (name) => {
  const response = await axios.get(`${API_URL}/name/${encodeURIComponent(name)}`);
  return response.data.data;
};

/**
 * Get all unique destination tags
 * @returns {Promise<Array<string>>} Array of unique tags
 */
export const getDestinationTags = async () => {
  const response = await axios.get(`${API_URL}/tags`);
  return response.data.data;
}; 